<template>
  <div class="command-bar-footer">
    <div class="command-bar-footer__instructions">
      <div class="command-bar-footer__instruction">
        <SbIllustration
          src="https://a.storyblok.com/f/136045/24x24/63b8fb9830/arrow-down-up.svg"
          alt="Navigate"
          width="24px"
        />
        To Navigate
      </div>
      <div class="command-bar-footer__instruction">
        <SbIllustration
          src="https://a.storyblok.com/f/136045/24x24/8ecd1cc6f3/corner-down-left.svg"
          alt="Select"
          width="24px"
        />
        To Select
      </div>
      <div class="command-bar-footer__instruction">
        <SbIllustration
          v-if="isMac"
          src="https://a.storyblok.com/f/136045/48x24/d6c779fc38/command-and-enter.svg"
          alt="Open in new tab"
          width="48px"
        />
        <span v-else class="command-bar-footer__instruction-key">Ctrl + K</span>
        To open in a new tab
      </div>
      <div class="command-bar-footer__instruction">
        <SbIllustration
          src="https://a.storyblok.com/f/136045/19x10/79f498a81c/esc.svg"
          alt="Exit"
          width="19px"
        />
        To exit
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { isMac as isMacParser } from '@utils/libraries/ua-parser'
import { SbIllustration } from '@storyblok/design-system'

// explicitly defined to show it in Vue DevTools
defineOptions({
  name: 'CommandBarFooter',
})

const isMac = computed(() => isMacParser())
</script>

<style lang="scss">
@import './command-bar-footer';
</style>
